<template>
<div class="chapter">
<div class="inner_page">
<p class="toca"><a id="page_x"></a><b>LIST OF TABLES</b></p>
<p class="toc1"><a href="#/html/9780292705111_ch3#ch3tab1">3.1 Changing Definitions of the Nuevo Santander–Texas Boundary</a></p>
<p class="toc1"><a href="#/html/9780292705111_ch3#ch3tab2">3.2 Population and Livestock in Rio Grande Settlements, 1757</a></p>
<p class="toc1"><span href="#/html/9780292705111_ch4#ch4tab1" title="Link target outside of Sample">4.1 Texas Mexican Population Changes</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch4#ch4tab2" title="Link target outside of Sample">4.2 Stronghold Counties of Mexican South Texas</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch5#ch5tab1" title="Link target outside of Sample">5.1 South Texas Plaza Town Characteristics</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch5#ch5tab2" title="Link target outside of Sample">5.2 Retail Properties by Type in McAllen’s Mexican American Downtown</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch5#ch5tab3" title="Link target outside of Sample">5.3 Selected Immigrant Residents from a Laredo Barrio</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch7#ch7tab1" title="Link target outside of Sample">7.1 Places with the Largest Absolute and Relative Mexican American Populations, 2000</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch7#ch7tab2" title="Link target outside of Sample">7.2 Texas Mexican–Operated Businesses in San Antonio’s Mexican Downtown, 1924</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch7#ch7tab3" title="Link target outside of Sample">7.3 San Antonio’s Mexican Population, 1900–2000</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch7#ch7tab4" title="Link target outside of Sample">7.4 Laredo’s Population for Selected Years</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch8#ch8tab1" title="Link target outside of Sample">8.1 <i>Barbacoa</i> Survey</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch8#ch8tab2" title="Link target outside of Sample">8.2 Taco Possibilities at El Pato Restaurant in McAllen, 1997</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch9#ch9tab1" title="Link target outside of Sample">9.1 Selected Tejano Surnames in San Antonio and Los Angeles</span></p>
<p class="toc1"><span href="#/html/9780292705111_ch9#ch9tab2" title="Link target outside of Sample">9.2 “South Texas” as a Business Name in Metropolitan Telephone Directories</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292705111_listoftables.vue?19380ded